import { selectBadge } from "@faire/retailer-visitor-shared/components/ProductBadge/badgeUtils";
import { handleShowroomProductBadgeViewed } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadgeUtils";
import { useProductTileClickImpressionContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressionContext";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
export var useRecordProductBadgeViewEvent = function(token, badgeList) {
    var recordImpressions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useProductTileClickImpressionContext = useProductTileClickImpressionContext(), requestId = _useProductTileClickImpressionContext.requestId, badgeEventTokens = _useProductTileClickImpressionContext.badgeEventTokens;
    return useEffectEvent(function() {
        if (!recordImpressions || !token || badgeEventTokens.has(token)) {
            return;
        }
        var _badgeList_badges;
        var topLeftTileBadge = selectBadge((_badgeList_badges = badgeList === null || badgeList === void 0 ? void 0 : badgeList.badges) !== null && _badgeList_badges !== void 0 ? _badgeList_badges : [], "TOP");
        handleShowroomProductBadgeViewed(token, requestId, topLeftTileBadge);
        badgeEventTokens.add(token);
    });
};
